const root = state => state.get('staffingCompanies');
const entities = state => root(state).get('entities');

export const staffingCompanyById = (state, id) => entities(state).get(String(id));
export const staffingCompaniesByIds = (state, ids) => ids.map(id => staffingCompanyById(state, id));
export const selectedStaffingCompanyId = state => state.getIn(['staffingCompanies', 'selectedStaffingCompanyId']);

